module.exports = {
  LOOTCOIN: 'lootcoin',
  DIAMOND: 'diamond',
};
